<template>
  <check-base-layout
    :pagetitle="pagetitle"
    :checkInfoData="checkFrom"
  >
    <template>
      <check-module :title="`合同总览`">
        <compart-module
          :compartData="checkFrom.orderContractBaseOtherPayVo"
          :is-deilvery="true"
        ></compart-module>
      </check-module>
      <check-module
        :tabsdata="tabsdata"
        :activeName="activeTabs"
        :is-table="true"
        @tabclick="tabclick"
      >
        <info-table
          :field-arr="bFieldArr"
          :table-data="bTableData"
          :table-height="`300px`"
          v-if="historyListData.payType !== 4"
        ></info-table>
        <div
          v-else
          style="margin-top: -20px;"
        >
          <div
            v-for="(item,index) in bTableData"
            :key="index"
          >
            <div>
              <el-row>
                <el-col :span="12">
                  <div style="padding:30px 0 14px;font-size:14px;font-weight: 500;">
                    <el-row>
                      <el-col :span='8'>{{item.shipName}}：{{item.shipPrice}}</el-col>
                      <el-col :span='8'>本期货款：{{item.shipTotal}}</el-col>
                      <el-col :span='8'>预计付款时间：{{item.shipPayDate}}</el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div
                    style="text-align: right;padding:30px 0 14px;"
                    v-show="item.shipTotal < item.shipPrice"
                  >
                    <i
                      class="el-icon-warning-outline"
                      style="color:#D35E5E;font-size: 16px;vertical-align: -1px"
                    ></i>
                    <span style="color:#D35E5E">本期货款＜本期产品报价总额</span>
                  </div>
                </el-col>
              </el-row>
              <info-table
                :field-arr="bFieldArr"
                :table-data="item.orderShipmentQueryVoList"
                :table-height="`auto`"
              ></info-table>
            </div>
          </div>
        </div>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="allTableData"
          :table-height="allTableData.length ? `73px` : 'auto'"
          :to-fixed-format="['cbPriceTotal','cbUnitTotal','money','contractTotal']"
        ></info-table>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :checkData="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'

export default {
  name: 'sellLackCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '销售报缺审批'
    }
  },
  data () {
    return {
      activeTabs: 'a',
      tabsdata: [
        {
          label: '报缺清单',
          name: 'a'
        },
        {
          label: '产品清单',
          name: 'b'
        }
      ],
      historyListData: {
        orderContractContentList: [],
        orderShipmentContentVoList: []
      },
      checkFrom: {
        orderContractLackPriceVo: {}
      }
    }
  },
  computed: {
    allFieldArr () {
      if (this.activeTabs === 'a') {
        return [{
          name: 'count',
          label: '报缺数量'
        }, {
          name: 'cbPriceTotal',
          label: '销售总额'
        }, {
          name: 'purchaseUnitPriceTotal',
          label: '采购总额'
        }]
      }
      return [{
        name: 'contractTotal',
        label: '销售总额'
      }, {
        name: 'money',
        label: '采购总额'
      }]
    },
    bFieldArr () {
      const n = this.activeTabs === 'b' ? '数量' : '报缺数量'
      return [{
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'seriesName',
        label: '系列'
      }, {
        name: 'proName',
        label: '产品名称'
      }, {
        name: 'proType',
        label: '型号'
      }, {
        name: 'orderNumber',
        label: '订货号'
      }, {
        name: 'count',
        label: n
      }, {
        name: 'cbUnit',
        label: '单位'
      }, {
        name: 'cbExtimeValue',
        label: '货期',
        formatter (val) {
          if (!val) return '--'
          // const d = val.split('-')
          // if (d.length !== 2) return val
          return val + '天'
        }
      }, {
        name: 'cbPrice',
        label: '单品报价'
      }, {
        name: 'cbRate',
        label: '毛利率'
      }, {
        name: 'cbUnitPrice',
        label: '供货单价'
      }, {
        name: 'purchaseUnitPrice',
        label: '采购单价'
      }]
    },
    bTableData () {
      if (this.activeTabs === 'b') {
        const { payType } = this.historyListData
        if (payType === 4) {
          return this.historyListData.orderShipmentContentVoList.map(item => {
            item.count = item.cbNumber
            return item
          })
        }
        return this.historyListData.orderContractContentList.map(item => {
          item.count = item.cbNumber
          return item
        })
      }
      return this.formatTableData(this.checkFrom.orderContentByDeliverCountVoList)
    },
    orderStockupContentVo () {
      return this.checkFrom.orderStockupContentVo || {}
    },
    allTableData () {
      return [{
        cbPriceTotal: this.checkFrom.orderContractLackPriceVo.cbPriceTotal,
        count: this.checkFrom.orderContractLackPriceVo.count,
        contractTotal: this.historyListData.contractTotal,
        money: this.historyListData.money,
        purchaseUnitPriceTotal: this.checkFrom.orderContractLackPriceVo.purchaseUnitPriceTotal
      }]
    }
  },
  mounted () {
    this.getSelllackInfo()
  },
  methods: {
    getSelllackInfo () {
      const {
        snaId
      } = this
      checkApi.getSelllackCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
          this.$emit('update:data', deepClone(res.data.obj))
        }
      })
    },
    formatTableData (data) {
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    },
    // tab切换
    tabclick (e) {
      this.activeTabs = e
      if (e === 'b') {
        const {
          ocbId
        } = this.checkFrom.orderContractLackPriceVo
        checkApi.getSelllackProlistCheckInfo({
          ocbId
        }).then(res => {
          if (isSuccess(res)) {
            this.historyListData = deepClone(res.data.obj)
          }
        })
      } else {
        this.getSelllackInfo()
      }
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  /deep/ .el-icon-warning-outline {
    padding-right: 10px;
  }
</style>
